module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Requisições Disponíveis")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "col-md-3 sidebar"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      staticClass: "col-sm-6 col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "panel panel-default panel-heading clickable",
      class: {
        'selected': tag === _vm.selectedTag
      },
      on: {
        "click": function($event) {
          _vm.selectedTag = tag
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-center"
    }, [_c('div', [_c('span', {
      staticClass: "huge"
    }, [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('span', {
      staticClass: "badge pull-right"
    }, [_vm._v(_vm._s(_vm.tagCount(tag)))])]), _vm._v(" "), _c('div')])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar..."
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.workflows.length > 0) ? _c('div', {
    staticClass: "list-group",
    attrs: {
      "id": "request-types-list"
    }
  }, _vm._l((_vm.filteredWorkflows), function(workflow) {
    return _c('router-link', {
      key: workflow.objectId,
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'RequestForm',
          params: {
            workflowId: workflow.objectId
          }
        }
      }
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v(_vm._s(workflow.name))]), _vm._v(" "), (workflow.reqType) ? _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(workflow.reqType.name))]) : _vm._e()])
  }), 1) : _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Não há fluxos cadastrados no sistema.\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-188957f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestOpen.vue
// module id = 1386
// module chunks = 1